import React, {Fragment, useState} from "react";
import {Button, Card, Col, Image, Input, Modal, Row} from "antd";
import {useTranslation} from "react-i18next";
import {extractLocalizedValue} from "../../../common";
import {ArrowRightOutlined} from "@ant-design/icons";
import {formatDateTime} from "../../../../../_common/function";

const VerificationHistoryModal_1 = ({userVerificationTiers, viewingRecord, isViewOpen, handleClose}) => {
    const {t} = useTranslation();
    const url = localStorage.getItem("verificationURL");

    const [steps, setSteps] = useState([]);

    const selectedTier = userVerificationTiers?.find(d => d?._id === viewingRecord?.tierSetting?._id)

    const resolveDisplayName = doc => extractLocalizedValue(doc?.displayName) || doc?.name;

    const mapSteps = (steps = [], sourceSteps = []) =>
        steps.map(step => {
            const found = sourceSteps?.find(d => d?.sourceId === step?.sourceId)

            return {
                ...step,
                displayName: resolveDisplayName(found?.sourceDoc),
                sourceType: found?.sourceType,
                type: found?.sourceDoc?.type,
                value:
                    found?.sourceType === "document_setting"
                        ? mapSteps(step?.value?.steps, found?.sourceDoc?.steps)
                        : step?.value,
            }
        })

    const formatDocuments = (viewingRecord, selectedTier) => {
        return viewingRecord?.documents?.map(doc => {
            const foundDoc = selectedTier?.documentSettings?.find(
                d => d?._id === doc._id
            )?.documentSettingDoc

            return {
                ...doc,
                displayName: resolveDisplayName(foundDoc),
                steps: mapSteps(doc?.steps, foundDoc?.steps),
            }
        })
    }

    const formatted = formatDocuments(viewingRecord, selectedTier)

    const getHeaderBreadcrumb = () => {
        const tier = extractLocalizedValue(viewingRecord?.tierSetting?.displayName) || viewingRecord?.tierSetting?.name

        let breadcrumbParts = tier ? [tier] : []

        let current = formatted?.find(d => d?._id === steps?.[0])
        if (current) breadcrumbParts.push(current?.displayName)

        for (let i = 1; i < steps.length; i++) {
            current = current?.steps?.find(s => s?.sourceId === steps[i])
            if (current) breadcrumbParts.push(current?.displayName)
        }

        return (
            <p className="mb-6">
                <strong>
                    <span className={"secondary-text me-2"}>
                        {extractLocalizedValue(viewingRecord?.flowSetting?.displayName) || viewingRecord?.flowSetting?.name}
                        {breadcrumbParts?.length > 0 && " / "}
                    </span>
                    {breadcrumbParts.map((part, idx) => {
                        const isLast = idx === breadcrumbParts.length - 1;
                        return (
                            <span key={idx} className={isLast ? "" : "secondary-text me-2"}>
                                {part} {!isLast && " / "}
                            </span>
                        )
                    })}
                </strong>
            </p>
        )
    }


    const DocumentCard = ({title, onClick}) => (
        <Col span={24}>
            <Card className="history-document-card">
                <Row wrap={false} align="middle">
                    <Col flex={1}>
                        {title}
                    </Col>
                    <Col flex={"32px"}>
                        <Button type="link" icon={<ArrowRightOutlined/>} onClick={onClick}/>
                    </Col>
                </Row>
            </Card>
        </Col>
    );

    const FieldDisplay = ({step}) => (
        <Fragment key={step?.sourceId}>
            <Col sm={24} md={12} className="mb-2">
                <div>
                    <label>{step?.displayName}</label>
                </div>
                {
                    step?.type === "file" && step?.value ? (
                        <Image src={`${url}/${step?.value}`}/>
                    ) : (
                        <Input value={t(step?.value?.toString())} disabled/>
                    )
                }
            </Col>
            {
                step?.expiredAt &&
                <Col sm={24} md={12} className="mb-2">
                    <div>
                        <label>{step?.displayName} - {t("userKycField.expired_date")}</label>
                    </div>
                    <Input value={formatDateTime(step?.expiredAt)} disabled/>
                </Col>
            }
        </Fragment>
    )

    const renderStepsRecursive = (stepsList = [], onNavigate) => {
        return stepsList?.filter(doc => doc?.value?.length || doc?.sourceType === "field_setting")?.map(step =>
            step?.sourceType === "document_setting" ? (
                <DocumentCard
                    key={step?.sourceId}
                    title={step?.displayName}
                    onClick={() => onNavigate(step?.sourceId)}
                />
            ) : (
                <FieldDisplay key={step?.sourceId} step={step}/>
            )
        );
    };

    return (
        <>
            <Modal
                destroyOnClose
                width={"60%"}
                title={
                    <div className={"text-small"}>
                        {getHeaderBreadcrumb()}
                    </div>
                }
                open={isViewOpen}
                onCancel={() => handleClose()}
                footer={null}
                getContainer={() => document.getElementById("accountVerificationV2")}
            >
                <Row gutter={[8, 8]}>
                    {(() => {
                        if (steps.length === 0) {
                            return formatted?.map(doc =>
                                <DocumentCard
                                    key={doc?._id}
                                    title={doc?.displayName}
                                    onClick={() => setSteps([doc?._id])}
                                />
                            );
                        }

                        let current = formatted?.find(d => d?._id === steps[0]);
                        for (let i = 1; i < steps.length; i++) {
                            current = current?.steps?.find(s => s?.sourceId === steps[i]);
                        }

                        return renderStepsRecursive(current?.steps || current?.value, (id) =>
                            setSteps(prev => [...prev, id])
                        );
                    })()}
                </Row>

                {
                    steps?.length > 0 &&
                    <Button
                        className={"mt-6"}
                        block
                        type={"default"}
                        onClick={() => setSteps(prev => prev.slice(0, -1))}
                    >
                        {t("common.back")}
                    </Button>
                }
            </Modal>
        </>
    )
}

export default VerificationHistoryModal_1;